import { Injectable } from '@angular/core';

import { ZzzConfigService } from './config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CoreInitService {
  constructor(private configService: ZzzConfigService) {}

  init(config: any): Promise<any> {
    return new Promise<any>((resolve) => {
      this.configService.init(config);
      resolve(null);
    });
  }
}
